import React from 'react'
import { Form } from 'react-bootstrap'
import * as Logger from 'loglevel'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFilter, faTimesCircle } from '@fortawesome/free-solid-svg-icons'
import './styles.module.css'

export class FilterSearchBar extends React.PureComponent {
    arePropsFullyInitialized() {
        var requiredKeys = ['searchText', 'setSearchText']
        var areMissingPropsDetected = false
        for (let i = 0; i < requiredKeys.length; i++) {
            if (this.props[requiredKeys[i]] === undefined) {
                Logger.error(
                    `The prop ${requiredKeys[i]} is missing.  Please add them to ensure that FilterSearchBar is built correctly`
                )
                areMissingPropsDetected = true
            }
        }
        return !areMissingPropsDetected
    }

    render() {
        if (!this.arePropsFullyInitialized())
            return (
                <div style={{ color: 'red' }}>
                    <b>
                        Missing FilterSearchBar Props. Please check the console for more
                        info.
                    </b>
                </div>
            )
        return (
            <div className='filterSearchDiv'>
                {this.props.searchText === '' ? (
                    <FontAwesomeIcon
                        className='filterSearchPlaceholderIcon'
                        icon={faFilter}
                    />
                ) : (
                    <FontAwesomeIcon
                        className='filterSearchPlaceholderIcon'
                        icon={faTimesCircle}
                        onClick={() => this.props.setSearchText('')}
                    />
                )}
                <Form.Control
                    onFocus={() =>
                        this.props.setIsFocusing ? this.props.setIsFocusing(true) : null
                    }
                    onBlur={() =>
                        this.props.setIsFocusing ? this.props.setIsFocusing(false) : null
                    }
                    type='text'
                    className='filterSearchBar'
                    placeholder='Filter Table Text...'
                    value={this.props.searchText}
                    onChange={(e) => this.props.setSearchText(e.target.value)}
                />
            </div>
        )
    }
}